@if (!(userLoggedIn | async)) {
  <div>
    @if (legalEntityListNew | async; as legalEntities) {
      <div
        class="dropdown legal-entity-container">
        @if (legalEntities?.length > 0) {
          @if (selectedLegalEntity | async; as selected) {
            <div>
              @if (selected) {
                <a data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                  class="nav-link dropdown-toggle secondary-anchor">
                {{(selected?.name)?selected.name:'Loading...'}}</a>
              }
            </div>
          }
          <div class="dropdown-menu mt-0 legal-entity-options">
            <input type="text" pInputText placeholder="{{'searchLegalEntity' | cxTranslate}}" class="dropdown-item-search"
              [(ngModel)]="searchText" />
              @for (legalEntity of legalEntities  | filterDropdown: searchText; track legalEntity) {
                <a class="dropdown-item"
                  (click)="onValueChange(legalEntity)">
                  {{legalEntity}}
                </a>
              }
            </div>
          } @else {
            <div class="loading-txt">Loading...</div>
          }
        </div>
      } @else {
        @if (legalEntityListSession?.length>0 && selectedLegalEntitySession?.name) {
          <div
            class="dropdown legal-entity-container">
            @if (selectedLegalEntity | async; as selected) {
              <a data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
              class="nav-link dropdown-toggle secondary-anchor">{{ selected.name }}</a>
            } @else {
              <a data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                class="nav-link dropdown-toggle secondary-anchor">
                {{selectedLegalEntitySession?.name}}
              </a>
            }
            <div class="dropdown-menu legalEntities-header mt-0 legal-entity-options">
              <input type="text" pInputText placeholder="{{'searchLegalEntity' | cxTranslate}}" class="dropdown-item-search"
                [(ngModel)]="searchText" />
                @for (legalEntity of legalEntityListSession | filterDropdown: searchText; track legalEntity) {
                  <a class="dropdown-item"
                    (click)="onValueChange(legalEntity)">
                  {{legalEntity}}</a>
                }
              </div>
            </div>
          } @else {
            <div class="loading-txt">Loading...</div>
          }
        }
      </div>
    }